import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { History } from "lucide-react";

export default function AuditTrail() {
  const { activeWorkspaceId } = useAuth();
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");
  const [actor, setActor] = useState("");

  useEffect(() => {
    if (!activeWorkspaceId) return;
    (async () => {
      const { data } = await api.get(`/workspaces/${activeWorkspaceId}/audit`);
      setLogs(data);
    })();
  }, [activeWorkspaceId]);

  const filtered = logs.filter(
    (l) => (!filter || l.action.includes(filter)) && (!actor || l.actor_name.toLowerCase().includes(actor.toLowerCase()))
  );
  const actions = [...new Set(logs.map((l) => l.action))];

  return (
    <div className="p-8 max-w-[1400px] mx-auto" data-testid="audit-page">
      <div className="mb-6">
        <div className="label-cap text-amber-500">// COMPLIANCE LOG</div>
        <h1 className="font-heading text-3xl font-extrabold text-slate-100 mt-1 flex items-center gap-2">
          <History className="w-6 h-6 text-amber-400" /> Audit Trail
        </h1>
      </div>

      <div className="flex gap-3 mb-4">
        <select value={filter} onChange={(e) => setFilter(e.target.value)}
          className="bg-slate-950/60 border border-slate-800 rounded-md px-3 py-2 text-sm text-slate-100"
          data-testid="audit-trail-filter-select">
          <option value="">All actions</option>
          {actions.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
        <input value={actor} onChange={(e) => setActor(e.target.value)} placeholder="Filter by actor…"
          className="bg-slate-950/60 border border-slate-800 rounded-md px-3 py-2 text-sm text-slate-100 flex-1"
          data-testid="audit-actor-filter" />
      </div>

      <div className="sc-card overflow-hidden">
        <table className="sc-table w-full">
          <thead>
            <tr><th>Timestamp</th><th>Actor</th><th>Action</th><th>Target</th><th>Details</th></tr>
          </thead>
          <tbody>
            {filtered.map((l) => (
              <tr key={l.id} data-testid={`audit-row-${l.id}`}>
                <td className="font-mono text-xs text-slate-400">{new Date(l.timestamp).toLocaleString()}</td>
                <td className="text-slate-200 font-semibold">{l.actor_name}</td>
                <td><span className="font-mono text-xs bg-slate-800/80 px-2 py-0.5 rounded">{l.action}</span></td>
                <td className="font-mono text-xs text-slate-500">{l.target?.slice(0, 12)}…</td>
                <td className="font-mono text-xs text-slate-500 max-w-md truncate">{JSON.stringify(l.meta)}</td>
              </tr>
            ))}
            {!filtered.length && <tr><td colSpan={5} className="text-center py-10 text-slate-500">No entries.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
